import { Input, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Axios from 'axios';
import { url } from 'utils/url';
import ReactQuill from 'react-quill';
import './Bugs.css';

import { setBreadcrumb } from 'state/actions/breadcrumb';

function Bugs() {
  const { userData } = useSelector(
    (state) => ({
      userData: state.auth.userData,
    }),
    shallowEqual
  );

  const [data, setData] = useState({
    description: '',
    email: userData.email,
    name: userData.name,
    title: '',
  });

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumb([{ menu: 'Bugs Report', link: 'bugs' }]));
  }, []); //eslint-disable-line

  const handleChangeText = (value) => {
    if (!loading) {
      setData({
        ...data,
        description: value,
      });
    }
  };

  const handleChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data.title && data.description) {
      setLoading(true);
      Axios.post(
        `${url}/email/send`,
        {
          content: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Bugs Report</title>
            <style type="text/css">
                /* devanagari */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrJJbecnFHGPezSQ.woff2) format('woff2');
                unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
                }
                /* latin-ext */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrJJnecnFHGPezSQ.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                }
                /* latin */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2) format('woff2');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                }
                /* devanagari */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLGT9Z11lFd2JQEl8qw.woff2) format('woff2');
                unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
                }
                /* latin-ext */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLGT9Z1JlFd2JQEl8qw.woff2) format('woff2');
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                }
                /* latin */
                @font-face {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLGT9Z1xlFd2JQEk.woff2) format('woff2');
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                }
            </style>
        </head>
        <body style="font-family: 'Poppins', 'sans-serif';">
            <div style="background-color: #F7F8FA; padding-bottom: 2rem;">
            <div style="background-color: #21486C; padding: 2rem;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <h1 style="color: #fff; font-size: 2em;">Bugs Report</h1>
                    <img src="data:image/png;base64,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"/>
                </div>
                <p style="color: #fff">Sep, 2nd 2021 10:44 AM</p>
                <div>
                    <table style="color: #fff">
                        <tbody>
                            <tr>
                                <td>Bugs Title:</td>
                                <td style="padding-left: 1rem;">${data.title}</td>
                            </tr>
                            <tr>
                                <td>Sender Name:</td>
                                <td style="padding-left: 1rem;">${data.name}</td>
                            </tr>
                            <tr>
                                <td>Sender Email:</td>
                                <td style="padding-left: 1rem;">${data.email}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div style="background-color: #fff; padding: 1rem 2rem; border-radius: 20px;
            box-shadow: 1px 6px 39px -5px rgb(0 0 0 / 23%); margin: 0px 4rem;
            margin-top: -4rem; display: flex;
            flex-direction: column;
            justify-content: space-between; min-width: 80vh;">
                <div style="color: #4F4F4F">
                    <p>Description</p>
                    ${data.description}
                </div>
                <div style="color: #828282; text-align: center;">
                    <p>Adactive Asia Ltd.</p>
                    <p>Singapore | https://capitaland.adsign.adactive.asia</p>
                </div>
            </div>
        
        </div>
        </body>
        </html>
          `,
          email: data.email,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      )
        .then((res) => {
          setData({
            title: '',
            description: '',
            email: userData.email,
            name: userData.name,
          });
          message.success(res.data.message);
        })
        .catch((err) => {
          if (err.response) {
            message.error(err.response.data.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      message.error('Fill the required data');
    }
  };

  console.log(data, 'data');

  return (
    <div className="bug-report">
      <h1 className="page-title">Bugs Report</h1>
      <p className="page-subtitle">
        If you happen to notice some issues, please write down the problems face
        in this manner: (example)
      </p>
      <div className="table-bugs-wrapper">
        <table className="table-bugs">
          <tbody>
            <tr>
              <th>Title:</th>
              <td>I cannot add new user</td>
            </tr>
            <tr>
              <th>Name:</th>
              <td>John Doe</td>
            </tr>
            <tr>
              <th>Email address:</th>
              <td>johndoe@example.com</td>
            </tr>
            <tr>
              <th>Description:</th>
              <td>
                I tried to add new user into adsign system. When I tried adding
                new user, the system prompted me with success. But when I check
                the User Management the user not exist
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <form className="form-wrapper">
        <div className="bugs-content">
          <div className="form">
            <label>
              Title <span className="is-required">*</span>
            </label>
            <Input
              value={data.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder="Title of the bugs you are facing"
            />
          </div>
          <div className="form">
            <label>
              Name <span className="is-required">*</span>
            </label>
            <Input
              disabled
              defaultValue={data.name}
              placeholder="Your username"
            />
          </div>
          <div className="form">
            <label>
              Email address <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Enter your email"
              value={data.email}
              onChange={(e) => handleChange('email', e.target.value)}
            />
          </div>
          <div className="form">
            <label>
              Description(Please also input how adactive developers can recreate
              the issue):
            </label>
            <ReactQuill
              modules={{
                toolbar: [
                  [{ header: '1' }, { header: '2' }],
                  [{ size: [] }],
                  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  [{ list: 'ordered' }, { list: 'bullet' }],
                ],
                clipboard: {
                  // toggle to add extra line breaks when pasting HTML:
                  matchVisual: false,
                },
              }}
              formats={[
                'header',
                'font',
                'size',
                'bold',
                'italic',
                'underline',
                'strike',
                'blockquote',
                'list',
                'bullet',
                'indent',
                'link',
                'image',
                'video',
              ]}
              theme="snow"
              value={data?.description}
              onChange={handleChangeText}
            />
          </div>
          <div className="form flex-end">
            {loading ? (
              <button className="button-send button-loading">
                <i className="feather-send" />
                Loading...
              </button>
            ) : (
              <button className="button-send" onClick={handleSubmit}>
                <i className="feather-send" />
                Send Report
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default Bugs;
